import { Routes, Route } from "react-router-dom";
import Pond from "pages/Pond";
import AddPond from "pages/AddPond";
import Ponds from "pages/Ponds";
import NotFound from "pages/NotFound";
import Main from "pages/Main";
import AnalyticsZone from "pages/AnalyticsZone";
import Explorer from "pages/Explorer";
import Home from "pages/home";
import Board from "pages/Board";
import SpaceDelete from "pages/SpaceDelete";
import SpaceDetailView from "components/SpaceDetailsView";

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/home" element={<Main />}></Route>
            <Route path="/dashboard" element={<Home />}></Route>
            <Route path="/:id" element={<Pond />}></Route>
            <Route path="/addPond" element={<AddPond />}></Route>
            <Route path="/analyticsZone" element={<AnalyticsZone />}></Route>
            <Route path="/explorer/:domain" element={<Explorer />}></Route>
            <Route path="/explorer/:domain/:spaceName" element={<SpaceDetailView />}></Route>
            <Route path="/board" element={<Board />}></Route>
            <Route path="/space_delete" element={<SpaceDelete />}></Route>
            <Route path="/404" element={<NotFound />}></Route>
        </Routes>
    );
}

export default AppRoutes;
